// Catalogo voci preset We Are Albero
// Ogni voce: { name, description }

export const CATEGORIES = [
  {
    key: "virtual-architecture",
    label: "Virtual Architecture",
    dot: "#3B82F6",
    items: [
      {
        name: "Rendering Esterni",
        description:
          "Realizzazione di immagini render esterne fotorealistiche mediante tecnologia CGI e photo merge di estrema fedeltà. Rilievo fotografico e modellazione 3D. Le immagini avranno una risoluzione tale da garantire stampe su grandi formati e cartellonistica.",
      },
      {
        name: "Rendering Interni",
        description:
          "Realizzazione di immagini render interne fotorealistiche degli ambienti più strategici e significativi del progetto, attraverso scatti fotografici virtuali. Con l'obiettivo di emozionare e trasmettere il lifestyle delle residenze.",
      },
      {
        name: "Virtual Tour 360°",
        description:
          "Visita virtuale immersiva a 360° con n. point of view selezionati. L'utente potrà immergersi negli ambienti godendo di una realistica percezione degli spazi e dei reali affacci.",
      },
      {
        name: "Short Film 3D",
        description:
          "Video rendering fotorealistico del progetto della durata di circa 90 secondi in alta definizione 4K. Racconto visivo coordinato attraverso riprese e animazioni fotorealistiche, montaggio e post-produzione. Formato compresso per canali social incluso.",
      },
      {
        name: "Short Film AI",
        description:
          "Video fotorealistico della durata di 60 secondi, realizzato con strumenti di Intelligenza Artificiale. Storytelling visivo per social media e canali digitali. Formato verticale ottimizzato per la diffusione sui principali canali online.",
      },
      {
        name: "Render Aerei / Fotoinserimento",
        description:
          "Realizzazione di immagini render aeree dell'intervento mediante tecnologia CGI e successivo fotoinserimento nel contesto territoriale di riferimento. Le immagini saranno sviluppate sulla base del modello tridimensionale di progetto.",
      },
      {
        name: "Fotosimulazioni 3D",
        description:
          "Elaborazioni grafiche fotorealistiche finalizzate alla rappresentazione dell'inserimento del progetto nel contesto urbano, infrastrutturale e paesaggistico. Per ciascuna vista: n. fotosimulazioni 3D con vista aerea e ad altezza uomo.",
      },
      {
        name: "Moodboard Architettonica",
        description:
          "Realizzazione di n. 1 impaginato in formato A4 contenente la descrizione grafica e testuale dei principali caratteri architettonici esterni del fabbricato, con indicazione di materiali, finiture e cromie.",
      },
    ],
  },
  {
    key: "architecture",
    label: "Architecture",
    dot: "#22C55E",
    items: [
      {
        name: "Valorizzazione Architettonica Esterna",
        description:
          "A partire dal progetto architettonico esistente, già sviluppato dallo studio incaricato, l'attività proposta riguarderà la prosecuzione e l'evoluzione dello studio dei prospetti esterni del fabbricato, con l'obiettivo di valorizzare l'immagine complessiva dell'edificio senza alterarne volumetrie e sagoma generale, salvo eventuali piccoli interventi puntuali da valutare in fase preventiva.\n\nLo studio si concentrerà sul miglioramento architettonico e percettivo dei prospetti attraverso soluzioni basate su finiture, parapetti, eventuali frangisole, lighting ed eventuali ulteriori elementi caratterizzanti, in coerenza con il linguaggio architettonico dell'immobile e con le aspettative del cliente.\n\nUna volta definito l'indirizzo progettuale, si procederà con un approfondimento tramite modellazione 3D ed elaborazioni grafiche, finalizzate alla definizione di:\n• finiture, materiali e rivestimenti dei prospetti;\n• parapetti, cielini, frangisole ed elementi architettonici caratterizzanti;\n• elementi di lighting design per l'illuminazione esterna.\n\nA supporto dello sviluppo progettuale saranno realizzati n. X rendering esterni fotorealistici, finalizzati a rappresentare con maggiore chiarezza la proposta architettonica e a consentire una piena percezione delle soluzioni progettuali, dei materiali, dei rivestimenti e del lighting design. L'immagine sarà priva di fotoinserimento.\n\nA conclusione del percorso progettuale, sarà consegnato un modello 3D architettonico di massima in formato .pln o similare.\n\nLo sviluppo progettuale proposto ha l'obiettivo di valorizzare l'intervento sotto il profilo architettonico, percettivo e funzionale, migliorando la qualità complessiva dell'immobile.\n\nL'attività non costituisce progettazione definitiva o esecutiva e non riguarderà aspetti strutturali, impiantistici o autorizzativi. La documentazione prodotta avrà valore di indirizzo progettuale e dovrà essere recepita dal tecnico incaricato o dal progettista di riferimento, che si occuperà della redazione degli eventuali elaborati necessari per pratiche edilizie, varianti in corso d'opera o ulteriori autorizzazioni richieste.",
      },
      {
        name: "Sviluppo Progetto Residenziale",
        description:
          "Studio e design preliminare, progettazione architettonica BIM, definizione layout unità abitative, studio materico e caratterizzazione architettonica del fabbricato.",
      },
      {
        name: "Interior Design — Completo",
        description:
          "Progettazione di interni completa: moodboard e sketches, definizione ambienti e tramezzature, controsoffitti e lighting, progettazione living/cucina/bagni/ambienti principali, selezione materiali e arredo.",
      },
      {
        name: "Progettazione Controsoffitti e Lighting",
        description:
          "Sviluppo della progettazione dei controsoffitti e del relativo sistema di illuminazione, in coerenza con il linguaggio stilistico degli ambienti. Definizione di geometrie, quote, punti luce, bocchette e diffusori di areazione.",
      },
      {
        name: "Design Scala Interna",
        description:
          "Progettazione architettonica della scala interna di collegamento tra i livelli. Definizione della configurazione geometrica, gradini, parapetti, corrimano, materiali e finiture. Approfondimento tramite modellazione 3D ed elaborati grafici quotati.",
      },
      {
        name: "Moodboard & Sketches Interior",
        description:
          "Fase preliminare di ricerca stilistica e concept design. Definizione dell'identità estetica: atmosfere, materiali, cromie, suggestioni progettuali. Output: book PDF con moodboard, palette cromatica, riferimenti stilistici.",
      },
      {
        name: "Planimetrie Quotate",
        description:
          "Sviluppo e definizione delle distribuzioni interne e delle tramezzature. Output: planimetrie architettoniche in formato DWG e PDF scala 1:100.",
      },
    ],
  },
  {
    key: "brand-building",
    label: "Brand Building & Art Direction",
    dot: "#A855F7",
    items: [
      {
        name: "Brand Identity",
        description:
          "Sviluppo di Brand Identity per garantire al progetto empatia e desiderio sul mercato di riferimento: logo, grafiche, moodboard e copywriting in funzione del target.",
      },
      {
        name: "Moodboard & Design",
        description:
          "Sviluppo dell'Interior Design degli ambienti più significativi attraverso finiture, arredi ed illuminazione. Trasmette emozione e atmosfera. Visualizzato attraverso Interior Virtual Photo e Virtual Tour.",
      },
      {
        name: "Floorplans Commerciali",
        description:
          "Planimetrie commerciali e tavole di vendita per ogni unità abitativa, con relative informazioni commerciali e tecniche, navigatore e QR code.",
      },
      {
        name: "Magazine di Progetto",
        description:
          "Brochure generale di progetto: la raccolta e il concentrato di comunicazione di tutta l'operazione. In formato sia digitale che cartaceo.",
      },
      {
        name: "Billboard & Banner",
        description:
          "Comunicazione visiva in linea con la Vision del progetto per il perimetro dell'area di cantiere. Connessione tra passanti, applicativi virtuali e pagina web con form di contatto.",
      },
      {
        name: "Shooting Fotografico",
        description:
          "Realizzazione della contenutistica fotografica nel quartiere e nella città. Minimo 10 scatti professionali.",
      },
    ],
  },
  {
    key: "digital-marketing",
    label: "Digital Marketing",
    dot: "#F97316",
    items: [
      {
        name: "Web Site Completo",
        description:
          "Sviluppo del sito web di progetto: home di atterraggio, selezionatore unità abitative (floor plans interattivi), gallery, descrizioni dell'intervento, form di contatto e ottimizzazione SEO.",
      },
      {
        name: "Landing Page",
        description:
          "Creazione della landing page dedicata al progetto. Pagina unica con menu di navigazione rapido, elaborati grafici, testi descrittivi e Call to Action per raccolta contatti. Acquisto dominio e hosting 12 mesi inclusi.",
      },
      {
        name: "Campagne Meta Ads",
        description:
          "1. Start-up e presidio multi-channel\n• Start-up dei canali Facebook e Instagram\n• Costruzione di una landing page mirata alla conversione dei contatti\n• Configurazione del Facebook Business Manager, dell'account pubblicitario e creazione dei pubblici\n• Configurazione del sistema di monitoraggio (Pixel)\n\n2. Digital & Social Media Strategy\n• Individuazione degli obiettivi in accordo con il cliente\n• Proposta della strategia e ottimizzazione per il raggiungimento degli obiettivi\n• Studio e ideazione della struttura del funnel\n\n3. Consulenza strategica e operativa\n• Creazione delle campagne Meta Ads (Instagram e Facebook) con obiettivo lead generation\n• Ottimizzazione data-driven e implementazione delle campagne in funzione dei dati raccolti\n• Copywriting in italiano\n• Report mensile di data analysis via email\n\n4. Planning & Media Buying su Meta Ads\n• Il budget da stanziare nelle campagne viene stimato in funzione di diversi fattori: periodo di lancio, competizione attuale, prezzi e appetibilità del prodotto offerto. Il budget pubblicitario resta a carico del cliente.",
      },
      {
        name: "Social Media & Digital Content",
        description:
          "Sviluppo contenuti e campagne ADV per i canali social. Creazione creatività, copywriting in italiano, ottimizzazione per la conversione.",
      },
      {
        name: "Consulenza Strategica Digitale",
        description:
          "Strategia di comunicazione digitale: definizione obiettivi, struttura del funnel, ottimizzazione campagne, report periodico.",
      },
    ],
  },
  {
    key: "integrated-software",
    label: "Integrated Software",
    dot: "#06B6D4",
    items: [
      {
        name: "LYNFA Suite Agency",
        description:
          "Applicativo gestionale per la commercializzazione immobiliare. Presentazione esperienziale delle iniziative, gestione clienti, preventivi e vendite in un'unica piattaforma. Accesso riservato per agenzie e developer.",
      },
      {
        name: "LYNFA Suite Manager",
        description:
          "Modulo gestionale dedicato a sviluppatori e venditori: gestione clienti, preventivi, monitoraggio vendite e reportistica avanzata.",
      },
      {
        name: "LYNFA Suite Client",
        description:
          "Sezione riservata ai clienti per consultare offerte, interagire con il team e configurare il proprio appartamento in tempo reale.",
      },
      {
        name: "Home Configurator 3D",
        description:
          "Applicativo sviluppato su unità campione per configurare e visualizzare in tempo reale le finiture con fedeltà fotorealistica. Pensato per supporto agli uffici vendita e agenti immobiliari.",
      },
    ],
  },
  {
    key: "in-store-hardware",
    label: "In-Store Hardware",
    dot: "#EF4444",
    items: [
      {
        name: 'Totem Multi Touch 27"',
        description:
          "Fornitura e installazione di Totem con sistema Touch Screen (computer integrato). Comprensivo di trasporto alla consegna, installazione degli applicativi, assistenza e ritiro a fine contratto.",
      },
      {
        name: "Visore VR PICO 4",
        description:
          "Fornitura e installazione di visore VR PICO 4 o similare, con tutti i contenuti e applicativi preinstallati. Comprensivo di trasporto e installazione.",
      },
    ],
  },
  {
    key: "personalizzata",
    label: "Personalizzata",
    dot: "#1A1A1A",
    items: [
      { name: "", description: "" },
    ],
  },
];

export const TAGLINES = [
  {
    label: "Virtual Architecture / rendering / film",
    text: "Attraverso la fusione di 3D art, tecnologia e linguaggio cinematografico, We Are Albero offre una rappresentazione del progetto architettonico capace di comunicare le sue tematiche con emozione e coinvolgimento.",
  },
  {
    label: "Marketing immobiliare / software / hardware",
    text: "In un'economia complessa e in rapida evoluzione, il settore del Real Estate contemporaneo esige nuove tecnologie per integrarsi col mercato e mantenere il passo.",
  },
  {
    label: "Interior design / architettura",
    text: "La qualità di uno spazio non si misura soltanto nelle sue dimensioni, ma nelle sensazioni che riesce a generare.",
  },
];

export const DEFAULT_LOGO =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_albero-quote-builder/artifacts/nkbc8b7j_Groueep%2054.png";

export const SENDER = {
  name: "WE ARE ALBERO",
  operativa: "Sede operativa: Via Giuseppe Verdi, 22-24 Pescara (PE)",
  legale: "Sede legale: Via Calpurnio Fiamma, 33 Roma (RM)",
  email: "info@alberoarchitetture.com",
  phone: "+39 3405319828",
  vat: "We Are Albero − P.Iva 15861221008",
  iban: "IT86O0303215401010000748731",
};
